import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = [
    "currentBilling",
    "currentBillingInput"
  ]

  static values = {
    clientId: Number
  }

  connect() {
    this.getCurrentBilling()
  }

  getCurrentBilling() {
    if (!this.hasCurrentBillingTarget || !this.clientIdValue) return

    this.currentBillingTarget.innerHTML = this.loadingElement()

    Rails.ajax({
      type: "GET",
      url: `/clients/${this.clientIdValue}/share_catalog_billed_product`,
      success: (data) => {
        const amount = parseFloat(data.annualized_billing || 0)

        this.currentBillingTarget.innerText = `${amount} € HT`
        if (this.hasCurrentBillingInputTarget) {
          this.currentBillingInputTarget.value = amount
        }

        this.dispatch("billing-loaded", {
          detail: { amount },
          prefix: "sellsy-share-catalog-subscription"
        })
      },
      error: () => {
        this.currentBillingTarget.innerText = "- €"
        if (this.hasCurrentBillingInputTarget) {
          this.currentBillingInputTarget.value = ""
        }

        this.dispatch("billing-loaded", {
          detail: { amount: null },
          prefix: "sellsy-share-catalog-subscription"
        })
      }
    })
  }

  loadingElement() {
    return `
      <span class="inline-flex items-center text-gray-500" aria-label="Chargement">
        <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.25" stroke-width="3"></circle>
          <path d="M21 12a9 9 0 0 0-9-9" stroke="#2C685A" stroke-width="3" stroke-linecap="round">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 12 12"
              to="360 12 12"
              dur="0.8s"
              repeatCount="indefinite" />
          </path>
        </svg>
      </span>
    `
  }
}
